import { useRef, memo } from "react";
import { ESIIncludeWithClientFetch } from "../__shared__/ESIIncludeWithClientFetch/ESIIncludeWithClientFetch";
import styles from "./Recommendations.module.scss";

export type Props = {
  /**
   * A string representing the product ID from the Product Information Management system.
   */
  productId: string;
  /**
   * A string representing the SKU ID of the product.
   */
  skuId: string;
  /**
   * A string representing the placement of the product.
   */
  placement: string;
  /**
   * A string representing the maximum number of products per page.
   */
  maxProductsPerPage: string;
  /**
   * A string indicating whether refresh is allowed.
   */
  allowRefresh?: string;
  /**
   * A string indicating Recommendation panel type
   */
  type?: "small" | "small-manual-recs";
  /**
   * Boolean that represents if responsive styling should be used
   */
  isResponsiveStylesEnabled?: boolean;
  /**
   * Boolean that represents if new premium button styling should be used
   */
  isCtaPremiumDesign?: boolean;
};

export const RecommendationsUI = memo(function RecommendationsUI({
  placement,
  productId,
  skuId,
  maxProductsPerPage,
  allowRefresh,
  type,
  isResponsiveStylesEnabled,
  isCtaPremiumDesign,
}: Props) {
  const className = isResponsiveStylesEnabled
    ? styles.recommendationSectionResponsive
    : "";

  const url = useRef(
    `/esi/recommendations/?${new URLSearchParams({
      placement,
      productId,
      skuId,
      ...(type ? { type } : {}),
      maxProductsPerPage,
      allowRefresh: allowRefresh || "false",
      withLoader: "true",
      ffWideLayout: "on",
      ...(className ? { className } : {}),
      ...(isCtaPremiumDesign ? { ffJLDSv31Patch: "off" } : {}),
    }).toString()}`,
  );

  return (
    <div
      data-testid={`recommendations-${placement.toLowerCase()}`}
      className="esi-wrapper"
      data-component="Recommendations"
    >
      <ESIIncludeWithClientFetch
        id={`jl-recommendations-panel-esi-${placement.toLowerCase()}`}
        src={url.current}
      />
    </div>
  );
});
